export default __webpack_public_path__ + "static/Circle Illustration 2-ecce54a376566cb8a517131d754775b0.png";